import { KICK_PARTICIPANT } from '../base/participants/actionTypes';
import MiddlewareRegistry from '../base/redux/MiddlewareRegistry';
import { kickSi } from './api';
import { cardOf } from './store';
/**
 * TPENGAGE: a kick of an SI's tile also reaches Kamo, which ends the SI's stay (Prosody refuses to kick its leg).
 */
MiddlewareRegistry.register(() => next => action => {
    if (action.type === KICK_PARTICIPANT) {
        const card = cardOf(action.id);
        if (card?.memberId) {
            kickSi(card.memberId);
        }
    }
    return next(action);
});
